import httpClient from 'api/httpClient';
import {
  WitnessedDocumentViewedEventProps,
  WitnessedListingVisitedEventProps,
} from 'models/MixpanelEvents';

function witnessedDocumentViewed(payload: WitnessedDocumentViewedEventProps) {
  return httpClient.post('mixpanel/witnessed-document-viewed', payload);
}

function witnessedListingVisited(payload: WitnessedListingVisitedEventProps) {
  return httpClient.post('mixpanel/witnessed-listing-visited', payload);
}

export default {
  witnessedDocumentViewed,
  witnessedListingVisited,
};
